// this component was automatically generated by IconGlyph.template.js
import type { FunctionComponent } from 'react';
import React from 'react';
import type { TestId } from '@trello/test-ids';

import type { IconSize } from '../src/components/Icon';
import { Icon } from '../src/components/Icon';

export interface GlyphProps {
  /**
   * A string that is applied as an aria attribute on the icon. Usually it
   * matches up with the display name of the icon
   * @default If no label is provided, it will fallback to the name of the icon
   */
  label?: string;
  /**
   * The color that the Icon should be rendered as.
   * @default token('color.icon', '#42526E')
   */
  color?: string;
  /**
   * The size to render the Icon size.
   * @default "medium"
   */
  size?: IconSize;
  /**
   * A string that gets placed as a data attribute (data-testid) onto the
   * Icon wrapper so that our
   * smoketest can properly target and test the component
   * @default undefined
   */
  testId?: TestId;
  // Escape hatches
  /**
   * ⚠️ DO NOT USE THIS PROP UNLESS YOU REALLY REALLY HAVE TO.
   *
   * Places a class name on the Icon (more specifically, the svg itself). This
   * is placed in addition to the classes already placed on the Icon. This is
   * placed directly onto the SVG via the glyph templates that are
   * generated by IconGlyph.template.js
   *
   * Please refrain from using this unless absolutely necessary.
   * @default undefined
   */
  dangerous_className?: string;
  /**
   * The switch for the icon to be centered in the dedicated space with padding around it.
   * Designed for cases when icon is not inline.
   */
  block?: boolean;
}

const UnlockedIconGlyph = () => {
  return (
    <svg
      width="24"
      height="24"
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24 0H0V24H24V0Z" fill="transparent" fillOpacity="0.01" />
      <path
        d="M5.00006 11.0089C5.00006 9.89887 5.89706 8.99988 7.00607 8.99988H16.9941C17.5263 9.00093 18.0363 9.21303 18.4124 9.58965C18.7884 9.96627 18.9998 10.4767 19.0001 11.0089V18.9909C19.0001 20.1009 18.1031 20.9998 16.9941 20.9998H7.00607C6.47377 20.9991 5.96354 20.787 5.58743 20.4103C5.21132 20.0337 5.00006 19.5232 5.00006 18.9909V11.0089ZM7.00007 10.9999V18.9999H17.0001V10.9999H7.00007Z"
        fill="currentColor"
      />
      <path
        d="M12.0001 16.9999C13.1046 16.9999 14.0001 16.1044 14.0001 14.9999C14.0001 13.8953 13.1046 12.9999 12.0001 12.9999C10.8955 12.9999 10.0001 13.8953 10.0001 14.9999C10.0001 16.1044 10.8955 16.9999 12.0001 16.9999Z"
        fill="currentColor"
      />
      <path
        d="M8.00006 6.00188C8.0006 4.94099 8.42213 3.92367 9.1721 3.17333C9.92207 2.42298 10.9392 2.00094 12.0001 1.99988C12.5255 1.99988 13.0458 2.10341 13.5313 2.30456C14.0167 2.50569 14.4577 2.80052 14.8292 3.17216C15.2007 3.54381 15.4953 3.98499 15.6962 4.47053C15.897 4.95606 16.0004 5.47643 16.0001 6.00188V6.49988H14.0001V6.00188C14.0002 5.73911 13.9486 5.47887 13.8481 5.23605C13.7477 4.99323 13.6004 4.77257 13.4147 4.58667C13.229 4.40076 13.0085 4.25327 12.7657 4.15257C12.523 4.05189 12.2628 4.00001 12.0001 3.99989C10.8981 3.99989 10.0001 4.89788 10.0001 6.00188V10.9999H8.00006V6.00188ZM14.0001 6.49988H16.0001C16.0001 6.76509 15.8948 7.01945 15.7071 7.20699C15.5196 7.39452 15.2654 7.49988 15 7.49988C14.7348 7.49988 14.4805 7.39452 14.293 7.20699C14.1054 7.01945 14.0001 6.76509 14.0001 6.49988Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UnlockedIcon: FunctionComponent<GlyphProps> = (props) => {
  const { testId, dangerous_className, size, color, label, block } = props;
  return (
    <Icon
      testId={testId}
      size={size}
      dangerous_className={dangerous_className}
      color={color}
      block={block}
      label={label || 'UnlockedIcon'}
      glyph={UnlockedIconGlyph}
    />
  );
};
